/**
 * API Configuration — Xyden Leadership Assessment Platform
 * Step 6F Green Phase
 */

const mocksEnabled = typeof import.meta !== 'undefined' && import.meta.env?.VITE_ENABLE_MOCKS === 'true';

export const API_BASE_URL = mocksEnabled ? '' : ((typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_BASE_URL) || '');

export const apiUrl = (path: string): string => `${API_BASE_URL}${path}`;
